'use client';
import React, { useState, createContext, useContext, useEffect } from "react";
import { useAxios } from "../utils/helpers";
import { useLoop } from "./loop-provider";
import { useLoopAuth } from "./auth-provider";

const LoyaltyContext = createContext(null);

export function LoyaltyProvider(props: any) {
    const [axios] = useAxios();
    const { store, integrations } = useLoop();
    const { myshopifyDomain } = useLoopAuth();

    const [isLoading, setisLoading] = useState(true);
    const [loyaltyProvider, setloyaltyProvider] = useState(null);

    const [canRedeemPoints, setcanRedeemPoints] = useState(false);
    const [minRedeemablePoints, setminRedeemablePoints] = useState(0);
    const [maxRedeemablePoints, setmaxRedeemablePoints] = useState(null);
    const [sliderSteps, setsliderSteps] = useState(0);
    const [availableBuckets, setavailableBuckets] = useState([]);
    const [pointsConversionAmount, setpointsConversionAmount] = useState(1);
    const [pointsConversionRate, setpointsConversionRate] = useState(0);

    const [points, setpoints] = useState(0);
    const [couponCount, setcouponCount] = useState(0);
    const [couponsList, setcouponsList] = useState([]);

    const [bubblehouseData, setbubblehouseData] = useState({
        isLoading: true,
        loyaltyProvider: null,
        points: 0,
        couponCount: 0,
        couponsList: [],
        token: null,
        link: null,
    });

    const [influenceData, setInfluenceData] = useState({
        isLoading: true,
        points: 0,
        couponCount: 0,
        loyaltyProvider: null,
        couponsList: [],
        redeemRule: [],
    });

    const [friendbuyData, setFriendbuyData] = useState({
        isLoading: true,
        points: 0,
        couponCount: 0,
        loyaltyProvider: null,
        couponsList: [],
        redeemRule: [],
    });

    const [yotpoData, setYotpoData] = useState({
        isLoading: true,
        points: 0,
        loyaltyProvider: null,
        redeemRule: [],
        pointsTransaction: [],
    });

    const [rivoData, setrivoData] = useState({
        loyaltyProvider: null,
        isLoading: true,
        points: 0,
        couponsCount: 0,
        couponsList: [],
        availableRewardsList: [],
    });

    const [riseaiData, setriseaiData] = useState({
        loyaltyProvider: null,
        isLoading: true,
        credits: 0,
        walletHistory: [],
    });

    const [okendoData, setokendoData] = useState({
        loyaltyProvider: null,
        isLoading: true,
        points: 0,
        coupons: [],
        redeemRules: [],
    });

    const loadData = async () => {
        setisLoading(true);
        setbubblehouseData({
            ...bubblehouseData,
            isLoading: true,
        });
        const [
            {
                data: { data },
            },
        ] = await Promise.all([
            axios.get(`${process.env.NEXT_PUBLIC_LOOP_BACKEND}/api/customer/v2/loyalty/bubblehouse/fetch`),
        ]);
        const _minRedeemablePoints = !Array.isArray(data.buckets)
            ? data.minRedeemablePoints
            : Math.min(...data.buckets);
        const _canRedeemPoints = data.points > 0 && data.points > _minRedeemablePoints;
        setminRedeemablePoints(data.minRedeemablePoints);
        setmaxRedeemablePoints(data.maxRedeemablePoints);
        setcanRedeemPoints(_canRedeemPoints);
        setsliderSteps(data.sliderSteps);
        setavailableBuckets(data.buckets);
        setpoints(data.points);
        setcouponCount(data.coupons.length);
        setcouponsList(data.coupons);
        setpointsConversionAmount(1);
        setpointsConversionRate(data.pointsConversionRate);
        setloyaltyProvider(data.provider);
        setisLoading(false);
        const slug = myshopifyDomain.replace(".myshopify.com", "");
        setbubblehouseData({
            isLoading: false,
            loyaltyProvider: data.provider,
            points: data.points,
            couponCount: data.coupons.length,
            couponsList: data.coupons,
            token: data.token,
            link: `https://app.bubblehouse.com/s/shopify-${slug}/sso/auth/${data.token}?return_url=https://${myshopifyDomain}/apps/bubblehouse/rewards`,
        });
    };

    const loadDataInfluence = async () => {
        setInfluenceData({
            ...influenceData,
            isLoading: true,
        });
        const [{ data: data }] = await Promise.all([
            axios.get(`${process.env.NEXT_PUBLIC_LOOP_BACKEND}/api/customer/v2/loyalty/influence/fetch`),
        ]);

        setInfluenceData({
            isLoading: false,
            couponCount: data?.data?.customerRewards?.length || 0,
            couponsList: data?.data?.customerRewards || [],
            points: data?.data?.customerStats?.points || 0,
            redeemRule: data?.data?.redeemRules || [],
            loyaltyProvider: data?.data?.provider,
        });
    };

    const loadDataFriendbuy = async () => {
        setFriendbuyData({
            ...friendbuyData,
            isLoading: true,
        });
        const [{ data: data }] = await Promise.all([
            axios.get(`${process.env.NEXT_PUBLIC_LOOP_BACKEND}/api/customer/v2/loyalty/friendbuy/fetch`),
        ]);

        setFriendbuyData({
            isLoading: false,
            couponCount: data?.data?.customerRewards?.length || 0,
            couponsList: data?.data?.customerRewards || [],
            points: data?.data?.customerPoints?.points || 0,
            redeemRule: data?.data?.redemptionOptions || [],
            loyaltyProvider: data?.data?.provider,
        });
    };

    const loadDataYotpo = async () => {
        setYotpoData({
            ...yotpoData,
            isLoading: true,
        });
        const [{ data: data }] = await Promise.all([
            axios.get(`${process.env.NEXT_PUBLIC_LOOP_BACKEND}/api/customer/v2/loyalty/yotpo/fetch`),
        ]);

        setYotpoData({
            isLoading: false,
            points: data?.data?.customerData?.pointBalance || 0,
            redeemRule: data?.data?.redemptionOptions || [],
            loyaltyProvider: data?.data?.provider,
            pointsTransaction:
                data?.data?.customerData?.pointsTransaction?.sort(
                    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
                ) || [],
        });
    };

    const loadDataRivo = async () => {
        setrivoData({
            ...rivoData,
            isLoading: true,
        });
        const [{ data: data }] = await Promise.all([
            axios.get(`${process.env.NEXT_PUBLIC_LOOP_BACKEND}/api/customer/v2/loyalty/rivo/fetch`),
        ]);
        setrivoData({
            isLoading: false,
            points: data.data.customerData.points,
            couponsCount: data.data.customerRewards.length,
            availableRewardsList: data.data.rewardsList,
            loyaltyProvider: data.data.provider,
            couponsList: data.data.customerRewards,
        });
    };

    const loadDataRiseai = async () => {
        setriseaiData({
            ...riseaiData,
            isLoading: true,
        });
        const [{ data: data }] = await Promise.all([
            axios.get(`${process.env.NEXT_PUBLIC_LOOP_BACKEND}/api/customer/v2/loyalty/rise-ai/fetch`),
        ]);
        setriseaiData({
            isLoading: false,
            credits: data.data.customerData.credits,
            loyaltyProvider: data.data.provider,
            walletHistory: data.data.walletHistory,
        });
    };

    const loadDataOkendo = async () => {
        setokendoData({
            ...okendoData,
            isLoading: true,
        });
        const [{ data: data }] = await Promise.all([
            axios.get(`${process.env.NEXT_PUBLIC_LOOP_BACKEND}/api/customer/v2/loyalty/okendo/fetch`),
        ]);
        setokendoData({
            isLoading: false,
            points: data.data.customerData.points,
            loyaltyProvider: data.data.provider,
            redeemRules: data.data.redeemRules,
            coupons: data.data.customerData.coupons,
        });
    };

    const loadAllIntegrations = async () => {
        if (store && integrations?.bubblehouse?.isConnected) {
            loadData();
        }
        if (store && integrations?.["influence-io"]?.isConnected) {
            loadDataInfluence();
        }
        if (store && integrations?.friendbuy?.isConnected) {
            loadDataFriendbuy();
        }
        if (store && integrations?.["yotpo-loyalty"]?.isConnected) {
            loadDataYotpo();
        }
        if (store && integrations?.rivo?.isConnected) {
            loadDataRivo();
        }
        if (store && integrations["rise-ai"]?.isConnected) {
            loadDataRiseai();
        }
        if (store && integrations["okendo"]?.isConnected) {
            loadDataOkendo();
        }
    };

    useEffect(() => {
        loadAllIntegrations();
    }, [store, integrations]);

    return (
        <LoyaltyContext.Provider
            value={{
                isLoading,
                loyaltyProvider,
                points,
                couponCount,
                couponsList,
                minRedeemablePoints,
                sliderSteps,
                loadData,
                availableBuckets,
                pointsConversionAmount,
                pointsConversionRate,
                canRedeemPoints,
                maxRedeemablePoints,
                loadDataInfluence,
                influenceData,
                friendbuyData,
                loadDataFriendbuy,
                yotpoData,
                loadDataYotpo,
                rivoData,
                loadDataRivo,
                riseaiData,
                loadDataRiseai,
                loadAllIntegrations,
                bubblehouseData,
                okendoData,
                loadDataOkendo,
            }}
        >
            {props.children}
        </LoyaltyContext.Provider>
    );
}

export const useLoyalty = () => useContext(LoyaltyContext);
